<span class="icon has-text-info" title="{{ title }}">
  <i class="fas {{ icon }}"></i>
</span>
